import { defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    recipes: {
      button: {
        variants: {
          variant: {
            outline: {
              borderColor: 'border.light',
            },
            secondaryOutline: {
              borderWidth: '1px',
              borderColor: 'border.light',
              bg: 'surface.background',
              color: 'text.primary',
              _hover: {
                bg: 'surface.accent',
              },
            },
            surfaceOutline: {
              borderWidth: '1px',
              borderColor: 'border.light',
              bg: 'surface.muted',
              color: 'text.primary',
              _hover: {
                bg: 'surface.accent',
              },
            },
          },
        },
      },
    },
  },
});

export default config;
